import base from '../../base'
import { createStoreModule } from 'v-select-box-vuex'
import axios from 'axios'

const capitalize = str => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

const endpoints = [
  {
    name: 'cadeia',
    resource: '/cadeia/publica',
    post: true
  },
  {
    name: 'indicadorGrupo',
    resource: '/indicadorgrupo/publica',
    map({ Id, Descricao }) {
      return { id: Id, text: Descricao, selected: false }
    },
    post: true
  },
  {
    name: 'indicador',
    resource: '/indicadorfinal/publica',
    map({ Id, IndicadorNome }) {
      return { id: Id, text: IndicadorNome, selected: false }
    },
    post: true
  },
  {
    name: 'estado',
    resource: '/estado/publica',
    post: true
  },
  {
    name: 'regiao',
    resource: '/regiao/publica',
    post: true
  },
  {
    name: 'cidade',
    resource: '/cidade/publica',
    post: true
  },
  {
    name: 'estadoDestino',
    resource: '/estado/seriehistorica',
    post: true
  },
  {
    name: 'regiaoDestino',
    resource: '/regiao/seriehistorica',
    post: true
  },
  {
    name: 'cidadeDestino',
    resource: '/cidade/seriehistorica',
    post: true
  },
  {
    name: 'tipoLocalidadeDestino',
    resource: '/tipolocalidade/seriehistorica',
    map({ Id, Descricao }) {
      return { id: Id, text: Descricao, selected: false }
    },
    post: true
  },
  {
    name: 'safra',
    resource: '/safra/publica',
    map({ Id, Descricao }) {
      return { id: Id, text: Descricao, selected: false }
    },
    post: true
  },
  {
    name: 'privateCadeia',
    resource: '/cadeia/seriehistorica',
    post: true
  },
  {
    name: 'privateIndicadorGrupo',
    resource: '/indicadorgrupo/seriehistorica',
    map({ Id, Descricao }) {
      return { id: Id, text: Descricao, selected: false }
    },
    post: true
  },
  {
    name: 'privateIndicador',
    resource: '/indicadorfinal/seriehistorica',
    map({ Id, IndicadorNome }) {
      return { id: Id, text: IndicadorNome, selected: false }
    },
    post: true
  },
  {
    name: 'privateTipolocalidade',
    resource: '/tipolocalidade/seriehistorica',
    map({ Id, Descricao }) {
      return { id: Id, text: Descricao, selected: false }
    },
    post: true
  },
  {
    name: 'privateEstado',
    resource: '/estado/seriehistorica',
    post: true
  },
  {
    name: 'privateRegiao',
    resource: '/regiao/seriehistorica',
    post: true
  },
  {
    name: 'privateCidade',
    resource: '/cidade/seriehistorica',
    post: true
  },
  {
    name: 'privateSafra',
    resource: '/safra/seriehistorica',
    map({ Id, Descricao }) {
      return { id: Id, text: Descricao, selected: false }
    },
    post: true
  }
]

const modules = {}

endpoints.forEach(({ resource, name, map, post }) => {
  modules[name] = createStoreModule(
    base,
    resource,
    capitalize(name),
    map,
    axios,
    post
  )
})

export default {
  namespaced: true,
  modules
}
